import { render, staticRenderFns } from "./IframePage.vue?vue&type=template&id=b0183eaa&lang=pug&"
import script from "./IframePage.vue?vue&type=script&lang=js&"
export * from "./IframePage.vue?vue&type=script&lang=js&"
import style0 from "./IframePage.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports